// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

/**
 * How the four asset status tokens are named and coloured.
 *
 * Previously `pages/site-sections/asset-topology/types.ts`. It moved out of a
 * page directory because three unrelated surfaces read it — the Power Flow
 * legend, the KPI tiles, and the shell's asset detail panel — and a shared
 * vocabulary living inside one page's folder is how it ends up duplicated.
 */

import type { StatusToken } from './entityHelpers';

/**
 * `idle` deliberately reads as "No data / standby" rather than the design
 * prototype's "Idle / standby": `getStatusToken` collapses `offline` **and**
 * `unknown` into `idle`, so in practice most idle assets are ones the twin
 * publishes no telemetry for. Calling that "standby" would misrepresent the
 * data.
 */
export const STATUS_LABELS: Record<StatusToken, string> = {
  ok: 'Monitoring',
  warn: 'Degraded',
  fault: 'Fault',
  idle: 'No data / standby',
};

/** CSS custom-property name carrying each status colour, from helios-theme. */
export const STATUS_VARS: Record<StatusToken, string> = {
  ok: 'var(--st-ok)',
  warn: 'var(--st-warn)',
  fault: 'var(--st-fault)',
  idle: 'var(--st-idle)',
};

export const STATUS_ORDER: StatusToken[] = ['ok', 'warn', 'fault', 'idle'];
